import { render, staticRenderFns } from "./ProductListElement.vue?vue&type=template&id=030feddd&"
import script from "./ProductListElement.vue?vue&type=script&lang=js&"
export * from "./ProductListElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports